import { defineStore } from 'pinia'
import { ref, watch } from 'vue'
import { OrderEstimate, ProfileFields } from '../types/types.api'
import { CartItem, PromoCode } from '../types/types.user'

export const useAccountStore = defineStore('account', () => {
  const city = ref<string>('')
  const cityId = ref<number | null>(null)
  const citySelected = ref(false)
  const name = ref<string>('Войти')
  const asideModalActive = ref(false)
  const promo = ref<PromoCode>()
  const cartComment = ref<string>('')
  const selectedLocation = ref<{ id: number; title: string; iiko_id?: string | number } | null>(
    null
  )
  const categories = shallowRef<Array<{ id: number; name: string }>>([])
  const cart = ref<CartItem[]>([])
  const categoryActiveScrollIndex = ref(0)
  const estimate = ref<null | OrderEstimate>()
  const isEstimateLoading = ref(true)
  const stashAddress = ref()
  const orderInfo = reactive<{
    comment: string
    desired_time: string
    items: CartItem[]
    promocode: string | null
  }>({
    comment: '',
    desired_time: 'Побыстрее',
    items: [],
    promocode: '',
  })
  const desiredTime = ref('')
  const orderType = ref<string | null>(localStorage.getItem('order'))
  const profile = ref<ProfileFields | null>(null)
  const setProfile = (info: ProfileFields) => {
    profile.value = info
  }
  const setEstimate = (info: OrderEstimate) => (estimate.value = info)

  const categoriesSaveHeight = ref<{ minHeight: number; top: number }>({ minHeight: 0, top: 0 })

  const token = ref<string>(' ')
  const watchedStoriesIds = ref<number[]>([])
  const toastList = ref<CartItem[]>([])
  const noFooter = ref(false)
  const cachedFoodItem = ref(null)
  const needChangeLocation = ref(false)
  const keyboardHeight = ref('0px')
  const tempCart = ref<Partial<CartItem>[]>([])
  const locationModalIsOpen = ref(false)

  const phone = ref('')

  const setNeedChangeLocation = (state: boolean) => (needChangeLocation.value = state)
  const mockCartItems = ref<Array<any>>([])
  if (typeof window !== 'undefined') {
    if (localStorage.getItem('caksCity')) {
      city.value = localStorage.getItem('caksCity')?.replaceAll('"', '') as string
    } else {
      city.value = 'Пятигорск'
    }

    if (localStorage.getItem('caksCityId')) {
      cityId.value = +(localStorage.getItem('caksCityId')?.replaceAll('"', '') as string)
      citySelected.value = true
    } else {
      cityId.value = 0
    }

    watch(city, (newValue) => {
      localStorage.setItem('caksCity', JSON.stringify(newValue))
    })

    watch(cityId, (newValue) => {
      citySelected.value = true
      localStorage.setItem('caksCityId', JSON.stringify(newValue))
    })
  }
  const changeAsideModalActive = (value: boolean) => {
    asideModalActive.value = value
    console.log('asideModalActive.value', asideModalActive.value)
  }

  const changeActiveScrollIndex = (index: number) => {
    categoryActiveScrollIndex.value = index
  }

  const setPromo = (value: PromoCode) => (promo.value = value)
  const setLocation = (
    location: { id: number; title: string; iiko_id?: string },
    type?: string
  ) => {
    selectedLocation.value = location
    if (type) {
      orderType.value = type
    }
  }
  const clearCart = () => (cart.value = [])
  const clearLocation = () => (selectedLocation.value = null)
  const updateCartOnLocalStorage = () => {
    localStorage.setItem('cart', JSON.stringify(cart.value))
  }
  const setDesiredTime = (time: string) => (desiredTime.value = time)
  const pushNewItemOnCart = (item: CartItem) => {
    cart.value.push({
      ...item,
      id: cart.value[cart.value.length - 1]?.id + 1 || 1,
      amount: 1,
    })
  }
  const setCartComment = (comment: string) => {
    cartComment.value = comment
    orderInfo.comment = comment
  }

  const checkItemsEqual = (sameItem: CartItem, item: CartItem) => {
    const exModsJson = JSON.stringify(sameItem.extraModificators)
    const removedModsJson = JSON.stringify(sameItem.removedModificators)

    const itemExModsJson = JSON.stringify(item.extraModificators)
    const itemRemovedModsJson = JSON.stringify(item.removedModificators)

    const isBaseModsEqual = isBaseModsSame(sameItem, item)

    return (
      exModsJson === itemExModsJson && itemRemovedModsJson === removedModsJson && isBaseModsEqual
    )
  }

  const isBaseModsSame = (item: CartItem, cartItem: CartItem) => {
    if (item.baseModificators.length !== cartItem.baseModificators.length) return false

    let allBaseModificatorsItem: string[] = []
    let allBaseModificatorsCartItem: string[] = []
    item.baseModificators.forEach((item) => {
      allBaseModificatorsItem.push(item.variant_id)
    })
    cartItem.baseModificators.forEach((item) => {
      allBaseModificatorsCartItem.push(item.variant_id)
    })

    allBaseModificatorsItem = [...allBaseModificatorsItem].sort()
    allBaseModificatorsCartItem = [...allBaseModificatorsCartItem].sort()

    for (let i = 0; i < allBaseModificatorsItem.length; i++) {
      if (allBaseModificatorsItem[i] !== allBaseModificatorsCartItem[i]) return false
    }
    return true
  }

  const isExtraModsSame = (item: CartItem, cartItem: CartItem) => {
    if (item.extraModificators.length !== cartItem.extraModificators.length) return false

    let allBaseModificatorsItem: string[] = []
    let allBaseModificatorsCartItem: string[] = []
    item.extraModificators.forEach((item) => {
      allBaseModificatorsItem.push(item.modification_id)
    })
    cartItem.extraModificators.forEach((item) => {
      allBaseModificatorsCartItem.push(item.modification_id)
    })

    allBaseModificatorsItem = [...allBaseModificatorsItem].sort()
    allBaseModificatorsCartItem = [...allBaseModificatorsCartItem].sort()

    for (let i = 0; i < allBaseModificatorsItem.length; i++) {
      if (allBaseModificatorsItem[i] !== allBaseModificatorsCartItem[i]) return false
    }

    return true
  }

  const addToTempCart = (item: Partial<CartItem>) => {
    tempCart.value.push(item)
  }

  const addToCart = (item: CartItem) => {
    const sameItem = cart.value.find((el) => {
      let isBase = item.item.id && isBaseModsSame(el, item) && isExtraModsSame(el, item)
      return el.item.id === item.item.id && isBase
    })

    if (sameItem) {
      const isItemsEqual = checkItemsEqual(sameItem, item)

      if (isItemsEqual) {
        cart.value = cart.value.map((el) => {
          if (
            el.item.id === item.item.id &&
            isBaseModsSame(el, item) &&
            isExtraModsSame(el, item)
          ) {
            return { ...el, amount: el.amount + 1 }
          }

          return el
        })
      } else {
        const sameItemFromBaseMods = cart.value.find((el) => {
          let finded = undefined

          el.baseModificators.forEach((mod, index) => {
            if (el.baseModificators[index].variant_id === mod.variant_id) {
              finded = el
            }
          })

          return finded
        })

        if (sameItemFromBaseMods) {
          let isFind = false
          cart.value = cart.value.map((el) => {
            if (!isFind && el.item.id === item.item.id) {
              isFind = true

              return { ...el, amount: el.amount + 1 }
            }

            return el
          })
        } else {
          pushNewItemOnCart(item)
        }
      }
    } else {
      pushNewItemOnCart(item)
    }

    toastList.value.push({
      ...item,
    })

    updateCartOnLocalStorage()
  }
  const changeCartItemAmount = (itemId: number, action: 'increase' | 'decrease') => {
    const foundItem = cart.value.find((el) => el.id === itemId)

    if (foundItem) {
      switch (action) {
        case 'increase':
          foundItem.amount += 1

          toastList.value.push({
            ...foundItem,
          })
          break

        case 'decrease':
          if (foundItem.amount > 1) {
            foundItem.amount -= 1
          } else {
            removeFromCart(itemId)
          }
      }
    }

    updateCartOnLocalStorage()
  }
  const removeFromCart = (id: number) => {
    cart.value = cart.value.filter((el) => el.id !== id)
    updateCartOnLocalStorage()
  }

  return {
    phone,
    isEstimateLoading,
    city,
    cityId,
    citySelected,
    name,
    keyboardHeight,
    mockCartItems,
    cachedFoodItem,
    noFooter,
    token,
    asideModalActive,
    toastList,
    promo,
    selectedLocation,
    cart,
    categoriesSaveHeight,
    tempCart,
    needChangeLocation,
    setNeedChangeLocation,
    orderInfo,
    orderType,
    desiredTime,
    categoryActiveScrollIndex,
    watchedStoriesIds,
    profile,
    cartComment,
    categories,
    estimate,
    stashAddress,
    setProfile,
    changeAsideModalActive,
    setPromo,
    setDesiredTime,
    setLocation,
    setCartComment,
    clearCart,
    clearLocation,
    addToCart,
    changeCartItemAmount,
    removeFromCart,
    changeActiveScrollIndex,
    setEstimate,
    addToTempCart,
    locationModalIsOpen,
  }
})
